/** @format */

import React, { FunctionComponent, ReactElement, useEffect, useState } from 'react';
import GridContainer from '../../components/Grid/GridContainer';
import { SimCardServiceGroup, SimCardServiceTypeCollection, SimCardServiceTypeItem } from '../../interfaces/collections/SimCardServiceInterface';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import { useDispatch } from 'react-redux';
import Filter from '../../interfaces/forms/Filter';
import GridItem from '../../components/Grid/GridItem';
import { SimpleSelect, SimpleSelectElements } from '../../components/Adescom/SimpleSelect';
import ActivateFeatureButton from '../../components/Buttons/ActivateFeatureButton';
import i18n from '../../core/i18n';
import { ComponentParam } from './component/ComponentByGroup';
import { ComponentParamsDialog } from './component/ComponentParamsDialog';
import { FeatureVerbTypeMap } from '../../modules/features/FeaturesTypes';
import DeactivateFeatureButton from '../../components/Buttons/DeactivateFeatureButton';
import { ComponentParamsDialogVc } from './component/ComponentParamsDialogVc';
import SelectApiList from '../lib/SelectApiList';

type ServicesByGroupType = {
    simCardServicesGroup: SimCardServiceGroup;
    operatorTypes: Array<number>;
    addCallback(componentParams: ComponentParam): void;
    platformResellerId?: number | null;
    isVc?: boolean;
};

export const ServicesByGroup: FunctionComponent<ServicesByGroupType> = ({
    simCardServicesGroup,
    operatorTypes,
    addCallback,
    platformResellerId,
    isVc,
}): ReactElement => {
    const dispatch = useDispatch();
    const [groupFeaturesList, setGroupFeaturesList] = useState<Array<SimCardServiceTypeItem> | null>(null);
    const [definitionComponent, setDefinitionComponent] = useState<SimCardServiceTypeItem | null>(null);
    const [selectedComponent, setSelectedComponent] = useState<number | null>(null);
    const [verbType, setVerbType] = useState<number | null>(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [isActivationMode, setIsActivationMode] = useState(true);

    useEffect(() => {
        if (groupFeaturesList === null) {
            const filters: Array<Filter> = [
                { name: 'pagination', value: false },
                { name: 'groupId', value: simCardServicesGroup.id },
            ];
            operatorTypes.map((oType) => {
                filters.push({ name: 'operatorType[]', value: oType });
            });
            if (platformResellerId) {
                filters.push({ name: 'platformResellerId', value: platformResellerId });
            }
            const loadItems = new ItemLoaders(dispatch);
            loadItems.getListWithCallback(
                FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/sim_card_service_types')),
                'group_load_features_list',
                filters,
                [{ name: 'description', value: 'asc' }],
                (data: SimCardServiceTypeCollection): void => {
                    setGroupFeaturesList(data['hydra:member']);
                },
                { propagateDataToCallback: true, dispatchAfterCallback: false }
            );
        }
    }, [dispatch, groupFeaturesList, simCardServicesGroup, operatorTypes, platformResellerId]);

    const closeCallback = (): void => {
        setOpenDialog(false);
        setDefinitionComponent(null);
        setVerbType(null);
    };

    const addCallbackLocal = (componentParams: ComponentParam): void => {
        addCallback(componentParams);
        closeCallback();
    };

    const confirmCallback = (verb: number): void => {
        if (selectedComponent && groupFeaturesList) {
            for (let i = 0; i < groupFeaturesList.length; i++) {
                if (groupFeaturesList[i].id === selectedComponent) {
                    setDefinitionComponent(groupFeaturesList[i]);
                    setVerbType(verb);
                    setOpenDialog(true);
                    break;
                }
            }
        }
    };

    const onChangeSelectEvent = (event: React.ChangeEvent<HTMLSelectElement>): void => {
        const field = event.target.name;
        const selected = event.target.value;
        setSelectedComponent(parseInt(selected));
    };

    const elementList: Array<SimpleSelectElements> = [];
    if (groupFeaturesList) {
        groupFeaturesList.map((item) => {
            if (item.simCardServiceTypeParam && item.simCardServiceTypeParam.length > 0) {
                elementList.push({ value: item.id, name: item.description ?? 'no-name' });
            }
        });
    }

    const callbackResponseParser = (groupFeaturesList:any): Array<any> => {
        const elementListLocal: Array<SimpleSelectElements> = [];
        if (groupFeaturesList['hydra:member']) {
            console.log(groupFeaturesList)
            groupFeaturesList['hydra:member'].map((item:any) => {
                if (item.simCardServiceTypeParam && item.simCardServiceTypeParam.length > 0) {
                    elementListLocal.push({ value: item.id, name: item.description ?? 'no-name' });
                }
            });
        }
        return elementListLocal;
    }

    return (
        <GridContainer style={{ marginTop: '15px' }}>
            {groupFeaturesList && groupFeaturesList.length > 0 && (
                <React.Fragment key={'service_by_group_list_' + simCardServicesGroup.id}>
                    <GridItem xs={8}>
                        {/*<SimpleSelect*/}
                        {/*    callback={onChangeSelectEvent}*/}
                        {/*    label={simCardServicesGroup.mainname}*/}
                        {/*    required={false}*/}
                        {/*    elements={elementList}*/}
                        {/*    dispatchName={'no-action'}*/}
                        {/*    selectedValue={selectedComponent ?? -1}*/}
                        {/*/>*/}

                        <SelectApiList
                            callbackResponseParser={callbackResponseParser}
                            optionValue={elementList}
                            addEmpty={true}
                            fullWidth={true}
                            emptyLabel={simCardServicesGroup.mainname}
                            filters={[
                                { name: 'pagination', value: false },
                                { name: 'groupId', value: simCardServicesGroup.id },
                                { name: 'itemsPerPage', value: 20 }
                            ]}
                            orders={[{ name: 'description', value: 'asc' }]}
                            iri={FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/sim_card_service_types'))}
                            fieldName={['searchTerm']}
                            handleChange={(fieldName, value): void => {
                                setSelectedComponent(value[0])
                            }}
                            useType={1}
                        />
                    </GridItem>
                    <GridItem xs={4} style={{ textAlign: 'right'}}>
                        <ActivateFeatureButton
                            nonTableButton
                            callback={(): void => {
                                setIsActivationMode(true);
                                confirmCallback(FeatureVerbTypeMap.ACTIVATE);
                            }}
                            callbackParam={{}}
                            tooltipTitle={i18n.t('prov:features.add_service')}
                            size="sm"
                        />
                        <DeactivateFeatureButton
                            nonTableButton
                            callback={(): void => {
                                setIsActivationMode(false);
                                confirmCallback(FeatureVerbTypeMap.DEACTIVATE);
                            }}
                            callbackParam={{}}
                            tooltipTitle={i18n.t('prov:features.delete_service')}
                            size="sm"
                        />
                    </GridItem>
                </React.Fragment>
            )}
            {definitionComponent && verbType && isVc && (
                <ComponentParamsDialogVc
                    verbType={verbType}
                    open={openDialog}
                    definitionComponent={definitionComponent}
                    closeCallback={closeCallback}
                    confirmCallback={addCallbackLocal}
                    isActivationMode={isActivationMode}
                    simCardId={-1}
                />
            )}
            {definitionComponent && verbType && !isVc && (
                <ComponentParamsDialog
                    verbType={verbType}
                    open={openDialog}
                    definitionComponent={definitionComponent}
                    closeCallback={closeCallback}
                    confirmCallback={addCallbackLocal}
                    isActivationMode={isActivationMode}
                    simCardId={-1}
                />
            )}
        </GridContainer>
    );
};
